import { useNavigate } from "react-router-dom";
import { Store, Clock, Truck, Bell, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const IMG = "https://images.pexels.com/photos/36754327/pexels-photo-36754327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function PerBar() {
  const navigate = useNavigate();
  const features = [
    { icon: Store, title: "Il tuo menu, i tuoi prezzi", desc: "Crea pacchetti, inserisci prodotti, allergeni, prezzi e disponibilità." },
    { icon: Clock, title: "Orari e chiusure", desc: "Imposta orari di apertura, giorni di chiusura e disponibilità in tempo reale." },
    { icon: Truck, title: "Ritiro o consegna", desc: "Scegli se offrire ritiro, consegna o entrambi, con raggio e costo personalizzati." },
    { icon: Bell, title: "Ordini in tempo reale", desc: "Ricevi, accetta o rifiuta gli ordini con notifica sonora e visiva." },
  ];
  return (
    <div>
      <section className="bg-cream">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
          <img src={IMG} alt="Pasticceria" className="rounded-3xl brand-shadow w-full h-[420px] object-cover order-2 lg:order-1" />
          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-orange bg-orange/10 px-4 py-1.5 rounded-full">
              <Store className="w-3.5 h-3.5" /> Per bar e pasticcerie
            </span>
            <h1 className="mt-6 text-4xl lg:text-5xl font-extrabold text-navy tracking-tight">Nuovi clienti dai B&B della tua zona</h1>
            <p className="mt-4 text-lg text-navy/70 leading-relaxed">
              Raggiungi gli ospiti delle strutture ricettive vicine. Gestisci ordini e menu da un'unica dashboard semplice e veloce.
            </p>
            <Button onClick={() => navigate("/registra/locale")} className="mt-8 rounded-full bg-navy text-white h-12 px-6" data-testid="perbar-register-btn">
              Registra il tuo locale
            </Button>
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid sm:grid-cols-2 gap-5">
        {features.map((f, i) => (
          <div key={i} className="bg-white border border-navy/10 rounded-2xl p-7 hover:shadow-md transition-shadow">
            <div className="w-12 h-12 rounded-xl bg-cream flex items-center justify-center"><f.icon className="w-6 h-6 text-orange" /></div>
            <p className="mt-4 font-semibold text-navy text-lg">{f.title}</p>
            <p className="mt-2 text-sm text-navy/60 leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-16">
        <div className="bg-navy rounded-3xl p-10 text-white">
          <h2 className="text-2xl font-bold">Gestione completa degli ordini</h2>
          <div className="mt-6 grid sm:grid-cols-2 gap-3">
            {["Ricevere e accettare ordini", "Rifiutare un ordine motivandone la causa", "Aggiornare lo stato dell'ordine", "Vedere vendite del giorno e del mese", "Gestire disponibilità prodotti", "Impostare 'Locale temporaneamente non disponibile'"].map((t) => (
              <div key={t} className="flex items-center gap-2 text-white/80"><CheckCircle2 className="w-5 h-5 text-orange shrink-0" />{t}</div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
